import type { DatasetCardDescriptionProps } from "./dataset-card-description.type";

import { Typography } from "antd";

const { Text } = Typography;

export const DatasetCardDescription = ({
  template,
  loading,
}: DatasetCardDescriptionProps) => {
  const { name, description } = template;

  if (!description?.length || loading || description === name) return null;

  return (
    <Text className="dataset-card-template-description">{description}</Text>
  );
};
